// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-cards-historico {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);

}

.item-historico {
    /* display: flex; */
    /* width: 100%; */
}

.titulo {
    color: var(--aiAzul);
    margin-left: 12px;
}

.tabela-card {
    display: grid;
    grid-template-columns: 350px 150px 100px 120px 100px 350px;
}

.container-cards-historico h2 {
    color: var(--aiAzul);
    font-size: 15px;
}

.coe_rendimento{
  margin-top: 12px;

}
`, "",{"version":3,"sources":["webpack://./src/components/card-historico-pos/card-style.css"],"names":[],"mappings":"AAAA;IAKI;;AAHJ;;AAMA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,0DAA0D;AAC9D;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;EACE,gBAAgB;;AAElB","sourcesContent":[".container-cards-historico {\n\n}\n\n.container-cards-historico {\n    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n}\n\n.item-historico {\n    /* display: flex; */\n    /* width: 100%; */\n}\n\n.titulo {\n    color: var(--aiAzul);\n    margin-left: 12px;\n}\n\n.tabela-card {\n    display: grid;\n    grid-template-columns: 350px 150px 100px 120px 100px 350px;\n}\n\n.container-cards-historico h2 {\n    color: var(--aiAzul);\n    font-size: 15px;\n}\n\n.coe_rendimento{\n  margin-top: 12px;\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
